// El mundo que la persona está visitando ahora (tres mundos,
// docs/plan-tres-mundos.md), o null en su casa. Lo fija App a través de
// `setMundoTracking` (lib/eventTracking.js) y lo leen la telemetría y el
// estudio del piloto. Vive aparte para que quien lo lea no dependa de
// eventTracking (que muchas pruebas reemplazan por un doble).
let mundo = null;

export function fijarMundoActual(m) {
  mundo = m || null;
}

export function mundoActual() {
  return mundo;
}
